<template>
  <div>
    <add-person-to-institution-modal
      v-if="isPowerUserOrAdministrator"
      :show="showPersonModal"
      :institution-id="linkedInstitutionId"
      @close="closePersonInstitutionModal"
    />

    <div>
      Liste des personnes
      <div v-if="personErrorMessage" class="validation-error mt-3">
        {{ personErrorMessage }}
      </div>
    </div>
    <div class="row text-left">
      <div class="col-md-12">
        <div class="card-body table-responsive table-full-width">
          <crud-list
            ref="crudList"
            :fetch-data="fetchPeople"
            :create-allowed="isPowerUserOrAdministrator && !editingDisabled"
            @row-clicked="personRowClicked"
            @create="createPersonInstitution"
          >
            <el-table-column label="Nom" min-width="50" property="lastName" />
            <el-table-column
              label="Prénom"
              min-width="20"
              property="firstName"
            />
            <el-table-column label="Titre professionnel" min-width="20">
              <div slot-scope="slotScope">
                {{ slotScope.row.jobTitle ? slotScope.row.jobTitle : '-' }}
              </div>
            </el-table-column>
            <el-table-column label="Est la personne de contact" min-width="20">
              <div slot-scope="slotScope">
                {{ slotScope.row.isContactPerson ? 'Oui' : 'Non' }}
              </div>
            </el-table-column>
            <el-table-column
              v-if="isPowerUserOrAdministrator && !editingDisabled"
              align="right"
              label="Action"
              min-width="20"
            >
              <div slot-scope="slotScope">
                <button
                  v-show="!editingDisabled"
                  type="button"
                  class="btn btn-icon btn-round btn-danger"
                  @click="removePersonInstitution(slotScope.row, $event)"
                >
                  <i class="fa fa-minus" />
                </button>
              </div>
            </el-table-column>
          </crud-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import swal from 'sweetalert2';
import AddPersonToInstitutionModal from 'src/components/ApplicationViews/Modals/AddPersonToInstitutionModal.vue';
import CrudList from '../CrudList.vue';

export default {
  name: 'PeopleInstitutionList',
  components: {
    AddPersonToInstitutionModal,
    CrudList,
  },
  props: {
    editingDisabled: Boolean,
    linkedInstitutionId: Number,
  },
  data() {
    return {
      showPersonModal: false,
      personErrorMessage: null,
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  methods: {
    fetchPeople(pageNumber, pageSize) {
      return this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/institutions/${
            this.linkedInstitutionId
          }/people?page=${pageNumber - 1}&size=${pageSize}`,
        )
        .then(response => ({
          records: response.data.content,
          page: {
            size: response.data.size,
            totalElements: response.data.totalElements,
            totalPages: response.data.totalPages,
            number: response.data.number,
          },
        }));
    },
    personRowClicked(person) {
      this.$router.push({
        name: 'PersonDetails',
        params: { id: person.id, newPersonCreation: false },
      });
    },
    createPersonInstitution() {
      this.showPersonModal = true;
    },
    closePersonInstitutionModal() {
      this.showPersonModal = false;
      this.$refs.crudList.fetch();
    },
    removePersonInstitution(person, event) {
      event.stopPropagation();

      this.personErrorMessage = null;

      swal({
        title:
          "Êtes-vous sûr de vouloir supprimer l'association entre cette institution et cette personne ?",
        text: "Il ne sera pas possible d'annuler cette suppression!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      }).then(() => {
        this.$http
          .delete(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/people/${person.id}/institutions/${this.linkedInstitutionId}`,
          )
          .then(response => {
            this.$refs.crudList.fetch();
          })
          .catch(error => {
            this.personErrorMessage =
              "Une erreur est survenue lors de la suppression de l'association entre l'institution et la personne, veuillez réessayer ou contacter le support.";
          });
      });
    },
  },
};
</script>

<style scoped></style>
